import { useState, useEffect } from "react";

const CelebrationLasers = ({ show }) => {
  const [particles, setParticles] = useState([]);
  
  useEffect(() => {
    if (show) {
      // Generate fewer confetti particles (more discrete)
      const newParticles = [];
      const colors = ['#ec00e8', '#00f7ff', '#ffd700'];
      
      for (let i = 0; i < 15; i++) {
        newParticles.push({
          id: i,
          left: Math.random() * 100,
          delay: Math.random() * 1,
          color: colors[Math.floor(Math.random() * colors.length)],
          size: Math.random() * 6 + 3
        });
      }
      setParticles(newParticles);
      
      // Clear after animation
      const timer = setTimeout(() => setParticles([]), 2500);
      return () => clearTimeout(timer);
    }
  }, [show]);
  
  if (!show) return null;
  
  return (
    <div className="celebration-container">
      {/* Fewer laser beams - more subtle */}
      <div className="celebration-laser magenta" style={{ left: '20%', animationDelay: '0s' }} />
      <div className="celebration-laser cyan" style={{ left: '50%', animationDelay: '0.3s' }} />
      <div className="celebration-laser magenta" style={{ left: '80%', animationDelay: '0.6s' }} />
      
      {/* Confetti */}
      {particles.map(p => (
        <div
          key={p.id}
          className="confetti"
          style={{
            left: `${p.left}%`,
            animationDelay: `${p.delay}s`,
            backgroundColor: p.color,
            width: `${p.size}px`,
            height: `${p.size}px`,
            borderRadius: '50%'
          }}
        />
      ))}
      
      {/* Single pulse ring */}
      <div className="pulse-ring" style={{ left: 'calc(50% - 60px)', top: '25%', width: '120px', height: '120px' }} />
    </div>
  );
};

export default CelebrationLasers;
